import { useQuery } from '@tanstack/react-query';
import * as actions from '@actions';
import { useDispatch } from 'react-redux';

export default function useUsersMeta() {
  const dispatch = useDispatch();

  const { data } = useQuery({
    queryKey: ['usersMeta'],
    queryFn: () => dispatch(actions.usersMeta()),
    select: (data) => data.meta?.[0]
  });

  return data;
}
